import {isRecord} from "./is_record";

// longer texts tend to be technical - the frontend copy is shown instead
const API_MESSAGE_MAX_LENGTH = 160;

export const isString = (value: unknown): value is string => typeof value === "string";

// a DRF error is a single text or a list of them
export const getFirstString = (value: unknown): string | null => {
    if (isString(value)) {
        return value;
    }

    return Array.isArray(value) ? (value.find(isString) ?? null) : null;
};

// the machine-readable code of a business error - a field error on the submitted `code` is a list instead
export const getApiErrorCode = (data: unknown): string | null => (isRecord(data) && isString(data.code) ? data.code : null);

export const isDisplayableApiMessage = (message: string | null): message is string =>
    message !== null && message.trim().length > 0 && message.length <= API_MESSAGE_MAX_LENGTH && !message.includes("<");
import {isRecord} from "./is_record";

// longer texts tend to be technical - the frontend copy is shown instead
const API_MESSAGE_MAX_LENGTH = 160;

export const isString = (value: unknown): value is string => typeof value === "string";

// a DRF error is a single text or a list of them
export const getFirstString = (value: unknown): string | null => {
    if (isString(value)) {
        return value;
    }

    return Array.isArray(value) ? (value.find(isString) ?? null) : null;
};

// the machine-readable code of a business error - a field error on the submitted `code` is a list instead
export const getApiErrorCode = (data: unknown): string | null => (isRecord(data) && isString(data.code) ? data.code : null);

export const isDisplayableApiMessage = (message: string | null): message is string =>
    message !== null && message.trim().length > 0 && message.length <= API_MESSAGE_MAX_LENGTH && !message.includes("<");
